import { render, staticRenderFns } from "./ScrollArrow.vue?vue&type=template&id=12b120c6"
import script from "./ScrollArrow.vue?vue&type=script&lang=js"
export * from "./ScrollArrow.vue?vue&type=script&lang=js"
import style0 from "./ScrollArrow.vue?vue&type=style&index=0&id=12b120c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports